<template>
  <div v-if="type === 1 || type === 2" class="game-tips-box">
    <div class="game-tips-txt">
      <img class="maintai-img" :src="type === 1 ? maintenance : online" alt="" />
      <div class="txt">{{ type === 1 ? $t("Datalang.HomePage_TIP_systemmaintence") : $t("Datalang.Home_Coming_soon") }}</div>
    </div>
  </div>
</template>

<script>
import gameMaintai from "@/lobby_common/mixins_components/game/game-maintai.js";
export default {
  components: {},
  props: [],
  mixins: [gameMaintai],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.game-tips-box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: var(--radius-300);
  z-index: 1000;

  .game-tips-txt {
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 99%;
    z-index: 2;
    color: var(--font-color-200);
    text-align: center;
    font-size: 18px;
    overflow: hidden;
    word-wrap: break-word;
    line-height: 14px;
    .maintai-img{
      width: 60%;
      max-width: 95px;
      margin-bottom: 10px;
    }
    .txt {
      font-size: 14px;
      width: 92%;
      margin: 0 auto;
      white-space: break-space !important;
      word-wrap: break-word;
      overflow: hidden;
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    p {
      font-size: 12px;
      // font-size: 14px;
    }
  }
}
@media (max-width: 768px) {
  .game-tips-box {
    // border-radius: 12px !important;
    .game-tips-txt {
      font-size: 14px !important;
    }
    p {
      font-size: 12px !important;
      margin: 2px 0;
    }
  }
}
</style>
